import {
  buildPath,
  buildTemplatePath,
  CrudMode,
  Dialog,
  handleClose,
  Page,
  PageRoute,
  ScreenType,
  useParams,
  useValidationErrors,
} from "@compass/core";
import {
  ApplicationResponseFile,
  FileTypeCategory,
  Permission,
  StudentApplicationEditResource,
  StudentFile,
  StudentServiceFile,
} from "generated/openApi";
import "moment-timezone";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ApiService from "services/apiService";
import { studentPageRoute } from "pages/students/students/StudentPage/StudentPage";
import { createEntity } from "utils";
import { FileDetailHeader } from "./FileDetailHeader";
import { FileDetailBody } from "./FileDetailBody";
import { FileDetailTypeEnum } from "./FileDetailTypeEnum";

const routeName = "fileDetail";

class Params {
  fileType: FileTypeCategory = FileTypeCategory.Application;
  screenType: ScreenType = "dialog";
  crudMode: CrudMode = "edit";
  parentEntityId: number = 0; //  ApplicationResponse (parent) => ApplicationResponseFile (child)
  entityId: number = 0;
}

export const fileDetailPageRoute: PageRoute<Params> = {
  handle: "Upload File",
  templatePath: buildTemplatePath(routeName, Params),
  getPath: (params) => buildPath(routeName, params),
};

export const FileDetailPage = () => {
  const { params } = useParams(routeName, Params);

  const navigate = useNavigate();
  const [applicationFileResource, setApplicationFileResource] = useState<StudentApplicationEditResource>();
  const [applicationResponseFile, setApplicationResponseFile] = useState<ApplicationResponseFile>();
  const [studentServiceFile, setStudentServiceFile] = useState<StudentServiceFile>();
  const [studentFile, setStudentFile] = useState<StudentFile>();
  const { validationErrors, setValidationErrors } = useValidationErrors();

  useEffect(() => {
    ApiService.studentApplications.getFileEditResource()
      .then((response) => {
        setApplicationFileResource(response);
      });

    if (params.entityId != 0) {
      if (params.fileType == FileTypeCategory.Application) {
        ApiService.studentApplications.getApplicationResponseFile(params.entityId)
          .then((response) => {
            setApplicationResponseFile(response);
          });
      }
      else if (params.fileType == FileTypeCategory.StudentServiceFile) {
        ApiService.studentServices.getStudentServiceFile(params.entityId)
          .then((response) => {
            setStudentServiceFile(response);
          });
      }
      else {
        ApiService.studentFiles.get(params.entityId)
          .then((response) => {
            response.studentId = params.parentEntityId;
            setStudentFile(response);
          });
      }
    }
    else {
      if (params.fileType == FileTypeCategory.Application) {
        let newFile: ApplicationResponseFile = createEntity<ApplicationResponseFile>({
          applicationResponseId: params.parentEntityId
        });
        setApplicationResponseFile(newFile);

        ApiService.studentApplications.getFileEditResource()
          .then((response) => {
            setApplicationFileResource(response);
          });
      }
      else if (params.fileType == FileTypeCategory.StudentServiceFile) {
        let newFile: StudentServiceFile = createEntity<StudentServiceFile>({
          studentServiceId: params.parentEntityId
        });
        setStudentServiceFile(newFile);

        ApiService.studentApplications.getFileEditResource()
          .then((response) => {
            setApplicationFileResource(response);
          });
      }
      else {
        ApiService.studentFiles.get(params.entityId)
          .then((response) => {
            response.studentId = params.parentEntityId;
            setStudentFile(response);
          });

        ApiService.studentApplications.getFileEditResource()
          .then((response) => {
            setApplicationFileResource(response);
          });
      }
    }

  }, []);

  const fetchGet = (id: number) => {
    if (params.fileType == FileTypeCategory.Application) {
      ApiService.studentApplications.getApplicationResponseFile(params.entityId)
        .then((response) => {
          setApplicationResponseFile(response);
        });
    }
    else if (params.fileType == FileTypeCategory.StudentServiceFile) {
      ApiService.studentServices.getStudentServiceFile(params.entityId)
        .then((response) => {
          setStudentServiceFile(response);
        });
    }
    else {
      ApiService.studentFiles.get(params.entityId)
        .then((response) => {
          response.studentId = params.parentEntityId;
          setStudentFile(response);
        });
    }
  };

  const reroute = (id: number, crudMode: CrudMode) =>
    navigate(`../${fileDetailPageRoute.getPath({ fileType: params.fileType, screenType: params.screenType, parentEntityId: params.parentEntityId, entityId: params.entityId,  crudMode: crudMode })}`);

  const pageHeader = (
    <FileDetailHeader
      crudMode={params.crudMode}
      applicationResponseFile={applicationResponseFile}
      studentFile={studentFile}
      studentServiceFile={studentServiceFile}
      entityId={params.entityId}
      fileType={params.fileType}
      reroute={reroute}
      fetch={fetchGet}
      onSave={(id) => {
        // navigate(`../${studentPageRoute.getPath({ id: id, crudMode: "view" })}`);
      }}
    />
  );

  const pageBody = (
    <FileDetailBody
      fileType={params.fileType}
      crudMode={params.crudMode}
      applicationFileResource={applicationFileResource}
      applicationResponseFile={applicationResponseFile}
      studentFile={studentFile}
      studentServiceFile={studentServiceFile}
      setEditingStudentFile={setStudentFile}
      setEditingStudentServiceFile={setStudentServiceFile}
      setEditingApplicationResponseFile={setApplicationResponseFile}
    />
  );

  return params.screenType === "standard" ? (
    <>
      <Page isForm header={pageHeader}>
        {pageBody}
      </Page>
    </>
  ) : (
    <Dialog
      isForm
      open={true}
      onClose={() => handleClose(navigate)}
      maxWidth="lg"
      header={pageHeader}
      content={pageBody}
    />
  );
};
